import * as React from 'react';

import { Translate } from 'react-localize-redux';

import { Option } from '@webapp/types/common/option';

import DropdownCtrl from '@webapp/controllers/form/dropdown';
import DropdownItemCheck from '@components/form/dropdown/dropdown-item-check';

interface ArtistDropdownRoleProps {
  id?: string;
  className?: string;
  value: string;
  roleList: Option[];
  isDisabled: boolean;
  hasMultipleSelect?: boolean;
  showError?: React.ReactNode;
  customBorderRadius?: string;
  isGrey?: boolean;
  onChange: (value: string) => void;
}

export const ArtistDropdownRole: React.FC<ArtistDropdownRoleProps> = (
  props
) => {
  const [filterValue, setFilterValue] = React.useState<string>('');

  const valueList = props.value
    .split(',')
    .filter((t) => !!t.length)
    .map((t) => t.trim());

  const handleMultiChange = (value: string) => {
    if (valueList.includes(value)) {
      // remove from list
      return props.onChange(valueList.filter((v) => v !== value).join(', '));
    }

    props.onChange(valueList.concat([value]).join(', '));
  };

  return props.hasMultipleSelect ? (
    <DropdownCtrl
      id={props.id}
      className={props.className}
      title={
        <Translate id="RELEASE.TRACK_INFO.TRACK.COLLABORATOR.DROPDOWN.LABEL" />
      }
      options={!props.hasMultipleSelect ? props.roleList : undefined}
      hasFilter
      filterLabel={
        <Translate id="RELEASE.TRACK_INFO.TRACK.COLLABORATOR.DROPDOWN.SEARCH" />
      }
      disabled={props.isDisabled}
      value={props.value}
      parentRelative
      noShadow
      isGrey={props.isGrey}
      showError={props.showError}
      redDot={props.showError ? true : false}
      customBorderRadius="0 2px 2px 0"
      onChange={!props.hasMultipleSelect ? props.onChange : undefined}
      onCustomFilter={(value) => {
        setFilterValue(value);
      }}
    >
      <div onClick={(ev) => ev.stopPropagation()}>
        {props.roleList
          .filter((r) =>
            r.label.toLowerCase().includes(filterValue.toLowerCase())
          )
          .map((role, i) => (
            <DropdownItemCheck
              key={i}
              checked={valueList.includes(role.value)}
              onChange={() => handleMultiChange(role.value)}
            >
              {role.label}
            </DropdownItemCheck>
          ))}
      </div>
    </DropdownCtrl>
  ) : (
    <DropdownCtrl
      id={props.id}
      className={props.className}
      title={
        <Translate id="RELEASE.TRACK_INFO.TRACK.COLLABORATOR.DROPDOWN.LABEL" />
      }
      options={props.roleList}
      hasFilter
      filterLabel={
        <Translate id="RELEASE.TRACK_INFO.TRACK.COLLABORATOR.DROPDOWN.SEARCH" />
      }
      disabled={props.isDisabled}
      value={props.value}
      parentRelative
      noShadow
      isGrey={props.isGrey}
      showError={props.showError}
      redDot={props.showError ? true : false}
      customBorderRadius={
        props.customBorderRadius ? props.customBorderRadius : '0 0 4px 4px'
      }
      onChange={props.onChange}
    />
  );
};

export default ArtistDropdownRole;
